import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { isNonEmptySubawardeeId } from '../utils/adminSubawardeeUtils';

interface AdminSubawardeeFilterStore {
  subawardee: string | null;
  setSubawardee: (value: string | null) => void;
}

export const useAdminSubawardeeFilterStore = create<AdminSubawardeeFilterStore>()(
  persist(
    (set) => ({
      subawardee: null,
      setSubawardee: (value) => {
        if (value === null || isNonEmptySubawardeeId(value)) {
          set({ subawardee: value });
        }
      },
    }),
    { name: 'admin-subawardee-filter' }
  )
);
